<template>
    <!--
        评分查询 - 查询结果
    -->
    <div class="page page-gradeQueryResult" v-loading="loading">
        <!-- title -->
        <!-- <div class="gradeQueryResult-head">
            <p>
                <span class="goback" @click="goBackBtn" v-if="isSaiWu == 'Score' ">
                    <i class="el-icon-arrow-left"></i>返回
                </span>
                <span class="head-span-line"></span>
                <span class="head-span-word">评分查询详情</span>
            </p>
            <div @click="getScoreDetail(2)">
                <div style="color: red;font-size: 22px"><i>{{ paperScore.toFixed(2) }}</i></div>
                <img src="@/assets/image/examinationImage/score_red.png" alt="">
            </div>
        </div> -->

        <!-- search -->
        <div class="gradeQueryResult-search">
            <el-tabs style="float: left;" v-model="activeName" @tab-click="handleClick">
                <el-tab-pane :label="`${$t('examListCom.SCT')}`" name="first"></el-tab-pane>
                <el-tab-pane :label="`${$t('examListCom.DDP')}`" name="second"></el-tab-pane>
                <el-tab-pane :label="`${$t('examListCom.TKT')}`" name="third"></el-tab-pane>
            </el-tabs>
            <!-- <el-col class="mr-20" style="width: 250px;">
                <el-input
                    clearable
                    v-model="questionStem"
                    placeholder="请输入试题题干"
                    size="mini"
                    style="width: 100%;"
                ></el-input>
            </el-col>
            <el-button v-if="tabName != 'ds'" type="primary" size="mini" @click="searchBtn()" icon="el-icon-search">查询</el-button> -->
            <span style="float: right;color: #9498A3;">
                {{ $t('examListCom.G') }}<strong style="color: #5397F7;margin: 0 5px;">{{ activeName === 'second' ? theoryListLen
                    : (activeName == 'third' ? thirdListLen : list.length) }}</strong>{{ $t('examListCom.TJG') }}
            </span>
        </div>

        <!-- main -->
        <div id="page" ref="gradeQueryResult_main" class="gradeQueryResult-main"
            :class="tabName == 'dxxl' ? 'gradeQueryResult-main-noExam' : ''">

            <div v-if="list.length && activeName === 'first'">
                <div v-for="(item, item_index) in list" :key="item_index">
                    <div class="questionInfo single_question" :class="{ 'questionMask': !item.isShowMore }"
                        :ref="'page' + item_index" :id="'page' + item_index">
                        <!-- 头部信息 -->
                        <p class="flex_header">
                            <span>
                                <span class="num">{{ item.questionNum }}、</span>
                                <span style="margin: 0 10px;">{{ $t('examListCom.ZF') }}：<strong
                                        style="color: red;margin: 0 5px;">{{ item.fullScore }}</strong>分</span>
                                <span style="margin: 0 10px;">{{ $t('examListCom.DSCORE') }}：
                                    <span v-show="item.blankStatus === 1">
                                        <strong style="color: #5397F7;margin: 0 5px;">{{ item.questionResult || '-'
                                        }}</strong>{{ $t('examListCom.SCORE') }}
                                    </span>
                                    <span v-show="item.blankStatus === 0 || item.blankStatus === undefined">
                                        <strong style="color: red;margin: 0 5px;">{{ $t('examListCom.WZD') }}</strong>
                                    </span>
                                </span>
                            </span>

                            <span class="child">
                                <!-- 查看评分详情 -->
                                <el-button v-auth="[['teacher', 'admin', 'student'], 'pro']"
                                    v-if="routeData.answerFlag !== 0" type="primary" plain size="mini"
                                    @click="goInto(item, item_index)">{{ $t('examListCom.CKPF') }}</el-button>
                            </span>
                        </p>
                        <el-divider></el-divider>
                        <p class="question_title">
                            <el-button v-show="!item.isShowMore" @click="changeIsShowMore(item)" type="info" size="mini">
                                {{ $t('examListCom.Zk') }}
                                <i class="el-icon-caret-bottom"></i>
                            </el-button>
                            <el-button v-show="item.isShowMore" @click="changeIsShowMore(item)" type="info" size="mini">
                                {{ $t('examListCom.SQ') }}
                                <i class="el-icon-caret-top"></i>
                            </el-button>
                        </p>
                        <!-- 题干 -->
                        <div class="div_content" v-html="item.questionContent"></div>
                    </div>
                </div>
            </div>
            <div class="noDatas" v-if="!list.length && activeName === 'first'">
                <img src="../../../assets/zanwu.png" />
                <p>{{ $t('examListCom.ZWSJ') }}</p>
            </div>
            <div v-if="theoryList.length && activeName === 'second'" class="section" @scroll="handleScroll" ref="content">
                <div class="test">
                    <ul>
                        <li :id="['page' + index]" v-for="(item, index) in theoryList" :key="index" class="test-item">
                            <div class="title">
                                {{ chnNumCharStr(index) }} 、{{ item.sectionName }}
                                <span>（{{ item.sectionPrompt }}）</span>
                            </div>
                            <ul>
                                <li class="test_small" v-for="(v, i) in item.questions" :key="i">
                                    <!--非组合题-->
                                    <div v-if="v.internalTypeId !== 6">
                                        <span class="text_index1"
                                            v-if="v.internalTypeId === 9 || v.internalTypeId === 10">{{ v.questionNum }}.（{{ v.score }}{{ $t('examListCom.SCORE') }}）</span>
                                        <span class="text_index"
                                            v-if="v.internalTypeId !== 9 && v.internalTypeId !== 10">{{ v.questionNum }}.（{{ v.score }}{{ $t('examListCom.SCORE') }}）</span>
                                        <div class="test_small_title1"
                                            v-if="v.internalTypeId === 9 || v.internalTypeId === 10">
                                            <p class="text" v-html="v.questionContent"></p>
                                        </div>
                                        <div class="test_small_title ql-editor" v-html="v.questionContent"
                                            v-if="v.internalTypeId !== 9 && v.internalTypeId !== 10"></div>
                                        <!--单选题-->
                                        <ul class="answer" v-if="v.internalTypeId === 1">
                                            <el-radio-group v-model="v.questionAnswer">
                                                <li v-for="(k, j) in v.items" :key="j">
                                                    <el-radio :label="k.itemKey"
                                                        :disabled="v.questionAnswer == k.itemKey ? false : true">
                                                        <span>{{ k.itemKey }}：</span>
                                                        <div class="radio_item ql-editor" v-html="k.itemValue"></div>
                                                    </el-radio>
                                                </li>
                                            </el-radio-group>
                                        </ul>
                                        <!--多选题-->
                                        <ul class="answer" v-if="v.internalTypeId === 2">
                                            <el-checkbox-group v-model="v.questionAnswerArr">
                                                <li v-for="(k, j) in v.items" :key="j">
                                                    <el-checkbox
                                                        :disabled="(v.questionAnswer ? v.questionAnswer.includes(k.itemKey) : false) ? false : true"
                                                        :label="k.itemKey">
                                                        <span>{{ k.itemKey }}：</span>
                                                        <p v-html="k.itemValue"></p>
                                                    </el-checkbox>
                                                </li>
                                            </el-checkbox-group>
                                        </ul>
                                        <!--判断题-->
                                        <ul class="answer" v-if="v.internalTypeId === 3">
                                            <li>
                                                <el-radio v-model="v.questionAnswer" :label="`${$t('examListCom.CORRECT')}`"
                                                    :disabled="v.questionAnswer == $t('examListCom.CW') ? true : false">{{
                                                        $t('examListCom.CORRECT') }}</el-radio>
                                            </li>
                                            <li>
                                                <el-radio v-model="v.questionAnswer" :label="$t('examListCom.CW')"
                                                    :disabled="v.questionAnswer == $t('examListCom.CORRECT') ? true : false">{{ $t('examListCom.CW') }}</el-radio>
                                            </li>
                                        </ul>
                                        <p
                                            v-if="v.internalTypeId === 1 || v.internalTypeId === 2 || v.internalTypeId === 3">
                                            {{ $t('examListCom.XSZD') }}：
                                            <span style="margin-right: 10px;"> {{ v.studentAnswers }}</span>
                                            {{ $t('examListCom.CORRECANSWER') }}:
                                            <span>{{ v.studentAnswer }}</span>
                                        </p>
                                        <div v-if="v.internalTypeId === 4">
                                            {{ $t('examListCom.CORRECANSWER') }}：
                                            <ul>
                                                <li v-for="(val, i, index) in v.newQuestionAnswer" :key="index">
                                                    {{ index + 1 }}：<span v-for="(answerVal, index) in val"
                                                        :key="index">{{ answerVal }}<span
                                                            v-if="val.length > 1 && index + 1 < val.length">、</span></span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div v-if="v.internalTypeId === 5">
                                            {{ $t('examListCom.CORRECANSWER') }}：
                                            <p class=" ql-editor" v-html="v.questionAnswer"></p>
                                        </div>
                                        <span v-if="!v.flag && v.internalTypeId !== 9 && v.internalTypeId !== 10"
                                            class="analysis_cont"
                                            v-html="v.questionAnalysis ? v.questionAnalysis : $t('examListCom.ZWJX')"></span>
                                    </div>
                                    <!--组合题-->
                                    <!-- <div
                                        class="line"
                                        v-if="v.internalTypeId === 6 && item.questions.length > 1"
                                    ></div> -->
                                    <div class="combination" v-if="v.internalTypeId === 6">
                                        <div class="test_small_title1"
                                            v-if="v.internalTypeId === 9 || v.internalTypeId === 10">
                                            <p class="text ql-editor" v-html="v.questionContent"></p>
                                        </div>
                                        <p class="question_index" v-show="v.childQuestions.length - 1 != 0">
                                            {{ $t('examListCom.YDYXNR') }} {{ v.questionNum }} - {{ v.questionNum +
                                                v.childQuestions.length - 1 }}{{ $t('examListCom.TI') }}</p>
                                        <p class="question_index" v-show="v.childQuestions.length - 1 == 0">
                                            {{ $t('examListCom.YDYXNR') }}{{ v.questionNum }}{{ $t('examListCom.TI') }}</p>
                                        <div class="test_small_title" v-html="v.questionContent"
                                            v-if="v.internalTypeId !== 9 && v.internalTypeId !== 10"></div>
                                        <div class="groupQuestion" v-for="(single, m) in v.childQuestions" :key="m">
                                            <div class="question_content">
                                                <span>{{ single.questionNum - 1 }}.
                                                    {{ $t('examListCom.ZF') }}:（{{ single.score }}{{ $t('examListCom.SCORE') }}）{{ $t('examListCom.DSCORE') }}:
                                                    ({{(single.allScore == 0 ? 0 : single.allScore ? single.allScore : '-') }}) {{ $t('examListCom.SCORE') }} 
                                                </span>
                                                <p class="text ql-editor"
                                                    v-if="single.internalTypeId == 1 || single.internalTypeId === 2 || single.internalTypeId == 3"
                                                    v-html="single.questionContent"></p>
                                            </div>
                                            <!--单选题-->
                                            <ul class="answer" v-if="single.internalTypeId === 1">
                                                <el-radio-group v-model="single.questionAnswer">
                                                    <li v-for="(k, j) in single.items" :key="j">
                                                        <el-radio :label="k.itemKey"
                                                            :disabled="single.questionAnswer == k.itemKey ? false : true">
                                                            <span>{{ k.itemKey }}：</span>
                                                            <div class="radio_item ql-editor" v-html="k.itemValue"></div>
                                                        </el-radio>
                                                    </li>
                                                </el-radio-group>
                                            </ul>
                                            <!--多选题-->
                                            <ul class="answer" v-if="single.internalTypeId === 2">
                                                <el-checkbox-group v-model="single.questionAnswerArr">
                                                    <li v-for="(k, j) in single.items" :key="j">
                                                        <!-- (single.questionAnswer ? single.questionAnswer.includes(k.itemKey) : false) ? false:true -->
                                                        <el-checkbox :disabled="true" :label="k.itemKey">
                                                            <span>{{ k.itemKey }}：</span>
                                                            <p class=" ql-editor" v-html="k.itemValue"></p>
                                                        </el-checkbox>
                                                    </li>
                                                </el-checkbox-group>
                                            </ul>
                                            <!--判断题-->
                                            <ul class="answer" v-if="single.internalTypeId === 3">
                                                <li>
                                                    <el-radio v-model="single.questionAnswer"
                                                        :label="$t('examListCom.CORRECT')"
                                                        :disabled="single.questionAnswer == $t('examListCom.CW') ? true : false">{{ $t('examListCom.CORRECT') }}</el-radio>
                                                </li>
                                                <li>
                                                    <el-radio v-model="single.questionAnswer" :label="$t('examListCom.CW')"
                                                        :disabled="single.questionAnswer == $t('examListCom.CORRECT') ? true : false">{{ $t('examListCom.CW') }}</el-radio>
                                                </li>
                                            </ul>
                                            <p
                                                v-if="single.internalTypeId === 1 || single.internalTypeId === 2 || single.internalTypeId === 3">
                                                {{ $t('examListCom.CORRECANSWER') }}：
                                                <span style="margin-right: 20px;">{{ single.questionAnswer }}</span>

                                                {{ $t('examListCom.XSDA') }}：
                                                <span>{{ single.answer == 'false' || !single.answer ? '-' :
                                                    single.answer }}</span>
                                            </p>
                                            <div v-if="single.internalTypeId === 4">
                                                {{ $t('examListCom.CORRECANSWER') }}：
                                                <ul>
                                                    <li v-for="(val, i, index) in single.newQuestionAnswer" :key="index">
                                                        {{ index + 1 }}：<span v-for="(answerVal, index) in val"
                                                            :key="index">{{ answerVal }}<span
                                                                v-if="val.length > 1 && index + 1 < val.length">、</span></span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div v-if="single.internalTypeId === 5">
                                                {{ $t('examListCom.CORRECANSWER') }}：
                                                <p class=" ql-editor" v-html="single.questionAnswer"></p>
                                            </div>
                                            <!-- <div
                                                class="analysis"
                                                v-if="single.flag && single.internalTypeId !== 9 && single.internalTypeId !== 10"
                                                @click="openAnalysis(single)"
                                            >
                                                打开解析
                                                <img :src="imgSrcDown" />
                                            </div> -->
                                            <!-- <div
                                                class="analysis"
                                                v-if="!single.flag && single.internalTypeId !== 9 && single.internalTypeId !== 10"
                                                @click="openAnalysis(single)"
                                            >
                                                收起解析
                                                <img :src="imgSrcUp" />
                                            </div>
                                            <span
                                                v-if="!single.flag && single.internalTypeId !== 9 && single.internalTypeId !== 10"
                                                class="analysis_cont ql-editor"
                                                v-html="single.questionAnalysis?single.questionAnalysis:'暂无解析'"
                                            ></span> -->
                                            <!-- <span
                                                class="answerShow"
                                                v-if="single.flag && (single.internalTypeId === 9 || single.internalTypeId === 10)"
                                                @click="openAnalysis(single)"
                                            >
                                                打开答案
                                                <img :src="imgSrcDown" />
                                            </span> -->
                                            <!-- <span
                                                class="answerHide"
                                                v-if="!single.flag && (single.internalTypeId === 9 || single.internalTypeId === 10)"
                                                @click="openAnalysis(single)"
                                            >
                                                收起答案
                                                <img :src="imgSrcUp" />
                                            </span> -->
                                            <div class="commentCont"
                                                v-if="!single.flag && (single.internalTypeId === 9 || single.internalTypeId === 10)">
                                                <div class="comment1"></div>
                                                <div class="comment2">
                                                    <my-component isShow :optObject="optObject" :refresh="refresh"
                                                        :myId="single.questionId" :type="type" :labelId="labelId" preview
                                                        :companyCode="companyCode"></my-component>
                                                </div>
                                                <div class="comment3"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="line" v-if="v.internalTypeId === 6 && item.questions.length > 1"></div>
                                    <div style="clear: both"></div>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="noDatas" v-if="!theoryList.length && activeName === 'second'">
                <img src="../../../assets/zanwu.png" />
                <p>{{ $t('examListCom.ZWSJ') }}</p>
            </div>
            <!-- 填空题 -->
            <div v-if="thirdList.length && activeName === 'third'" class="thirdDiv">
                <div class="test">
                    <ul>
                        <li :id="['page' + index]" v-for="(item, index) in thirdList" :key="index" class="test-item">
                            <div class="title">
                                {{ chnNumCharStr(index) }} 、{{ item.sectionName }}
                                <span>（{{ item.sectionPrompt }}）</span>
                            </div>
                            <ul>
                                <li class="test_small" v-for="(v, i) in item.questions" :key="i">
                                    <!--非组合题-->
                                    <div v-if="v.internalTypeId != 6">
                                        <span class="text_index"
                                            v-if="v.internalTypeId !== 9 && v.internalTypeId !== 10">{{ v.questionNum }}.（{{ v.score }}{{ $t('examListCom.SCORE') }}）</span>

                                        <div class="test_small_title ql-editor" v-html="v.questionContent"
                                            v-if="v.internalTypeId !== 9 && v.internalTypeId !== 10"></div>
                                        <div v-if="v.internalTypeId === 4" class="internalTypeBox">

                                            <div class="internalTypeLeft">
                                                <div class="xsda">{{ $t('examListCom.XSDA') }}：</div>
                                                <ul class="ulBox">
                                                    <li v-for="(val, i, index) in v.studentQuestionAnswer" :key="index"
                                                        style="display: flex;">
                                                        <div>{{ index + 1 }}：</div>
                                                        <div>
                                                            <span v-for="(answerVal, index) in val" :key="index"
                                                                style="color: #5397f7;">{{ answerVal }}<span
                                                                    v-if="val.length > 1 && index + 1 < val.length"></span></span>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div class="internalTypeRight">
                                                <div class="xsda">{{ $t('examListCom.CORRECANSWER') }}：</div>
                                                <ul class="ulBox">
                                                    <li v-for="(val, i, index) in v.newQuestionAnswer" :key="index"
                                                        style="display: flex;">
                                                        <div>{{ index + 1 }}：</div>
                                                        <div>
                                                            <span v-for="(answerVal, index) in val" :key="index"
                                                                style="color: #5397f7;">{{ answerVal }}<span
                                                                    v-if="val.length > 1 && index + 1 < val.length">、</span></span>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <!-- <span v-if="!v.flag && v.internalTypeId !== 9 && v.internalTypeId !== 10"
                                            class="analysis_cont"
                                            v-html="v.questionAnalysis ? v.questionAnalysis : $t('examListCom.ZWJX')"></span> -->
                                    </div>
                                    <div style="clear: both"></div>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="noDatas" v-if="!thirdList.length && activeName === 'third'">
                <img src="../../../assets/zanwu.png" />
                <p>{{ $t('examListCom.ZWSJ') }}</p>
            </div>
        </div>
        <scoreDetail ref="scoreDetail" />

        <paginator style="padding: 8px;" :pageSize="pageSize" :pageNum="pageNum" :total="total"
            @handleCurrentChange="currentPageFn" @handleSizeChange="sizeChangeFn" :current-page.sync="pageNum"
            @current-change="searchBtn(pageNum)" v-if="tabName == 'dxxl'"></paginator>

    </div>
</template>

<script>
import Api from "@/api/examinationApi";
import paginator from "../../components/paginator";
import scoreDetail from "./scoreDetail";

export default {
    name: "gradeQueryResult",
    components: {
        paginator,
        scoreDetail
    },
    props: {
        playerDetail: [Object],
    },
    data() {
        return {
            loading: false,
            questionStem: "", // 题干
            tabName: null,  // 入口类型
            code: null, // 准考证号
            examId: null, // 考生唯一id
            examPlan: null, // 考试计划code
            examPlanId: null, // 考试计划id
            courseCode: null, // 科目编码
            subjectId: null, // 科目id
            // paperCode: null, // 试卷编码
            questionCode: null, // 试题编码
            questionId: null, // 试题id
            studentName: null, // 考生姓名
            siteName: null, // 考点名称
            planName: null, // 计划名称
            // 考试
            testPaperCode: null, // 试卷code
            testPaperDatas: [],
            // 大赛
            matchType: null, // 大赛类型
            matchTeamId: null,        // 团队id
            matchPlayerId: null,        // 选手id
            matchPlanId: null,      // 计划id
            list: [], // 展示list
            listTS: [], // 暂存展示list
            // 理论题
            theoryList: [],
            defaultQuestionNum: 1,
            styleHeight: window.innerHeight - 110 + "px",
            chnNumChar: ["一", "二", "三", "四", "五", "六", "七", "八", "九"],
            contentList: [],
            userId: '',
            userType: '',
            userName: '',
            deptName: '',
            pageSize: 10,
            pageNum: 1,
            total: 0,
            imgSrcDown: require("@/assets/image/adminImage/down.png"),
            imgSrcUp: require("@/assets/image/adminImage/up.png"),
            allDatas: [],  // 单项模糊全部数据,
            // 学生总得分
            paperScore: 0,
            pageIndex: '',
            activeName: 'first',
            isSaiWu: '',
            thirdList: []
        };
    },
    computed: {
        theoryListLen() {
            let num = 0
            // console.log(this.theoryList)
            this.theoryList.forEach(item => (num += item.questions.length))
            return num
        },
        thirdListLen() {
            let num = 0
            this.thirdList.forEach(item => (num += item.questions.length))
            return num
        },
        routeData() {
            return JSON.parse(this.__Base64.decode(JSON.stringify(this.$route.query.q)))
        }
    },
    created() {
        this.getInfoOfPaperCode();
        this.getTheory();
        this.getScoreDetail(1);
    },
    watch: {
        playerDetail: {
            deep: true,
            immediate: false,
            handler() {
                this.getInfoOfPaperCode();
                this.getTheory();
                this.getScoreDetail(1);
            }
        }
    },
    filters: {
        mul(a) {
            if (a == null) {
                return 0
            } else {
                // 处理js浮点型计算bug
                let b = 100, c = 0,
                    d = a.toString(),
                    e = b.toString();
                try {
                    c += d.split(".")[1] ? d.split(".")[1].length : 0;
                } catch (f) {
                    console.log(f);
                }
                try {
                    c += e.split(".")[1] ? e.split(".")[1].length : 0;
                } catch (f) {
                    console.log(f);
                }
                return Number(d.replace(".", "")) * Number(e.replace(".", "")) / Math.pow(10, c);
            }
        }
    },
    mounted() {
        this.isSaiWu = sessionStorage.getItem('isSaiWu')
        this.scrollIndex(0)
    },
    methods: {
        handleClick() {
            console.log(this.activeName);
        },
        //阿拉伯数字转中文
        chnNumCharStr(index) {
            return this.chnNumChar[index];
        },
        handleScroll() {
            let scrollTop = this.$refs.content.scrollTop;
            let topicLi = document.querySelectorAll(".test-item");
            topicLi.forEach((item, index) => {
                if (scrollTop >= item.offsetTop - 120) {
                    this.activeName = "page" + index;
                }
            });
        },
        scrollIndex(i) {
            let timer = null
            let Page = document.getElementById('page')
            let pageIndex = sessionStorage.getItem("pageIndex") ? parseInt(sessionStorage.getItem("pageIndex"), 10) : i
            let pageId = document.getElementById('page' + pageIndex)
            if (pageId) {
                pageId.classList.add('selected')
                Page.scrollTo({
                    top: pageId.offsetTop - 230,
                    behavior: 'smooth'
                })
                if (timer) clearTimeout(timer)
            } else {
                timer = setTimeout(() => {
                    this.scrollIndex()
                }, 0)
            }
        },
        getScoreDetail(val) {
            const { matchPlanId, matchPattern, playerId, mainVersion, subVersion } = this.playerDetail;
            console.log(matchPattern, 'matchPattern')
            const teamId = matchPattern == 0 ? `${this.playerDetail.teamId}${mainVersion}${subVersion}` :
                `${parseInt(matchPlanId.toString().substr(-4))}${playerId}${mainVersion}${subVersion}`
            let obj = {
                matchPlanId,
                matchPattern: matchPattern === 2 ? 1 : matchPattern,
                teamId
            }
            const type = val
            Api.getScoreDetail(obj)
                .then(res => {
                    if (res.code === '0') {
                        this.paperScore = res.data.paperScore
                        if (type === 2) {
                            this.$refs.scoreDetail.show(res.data)
                        }
                    }
                })

        },
        changeIsShowMore(obj) {
            this.$set(obj, "isShowMore", !obj.isShowMore);
            this.$forceUpdate();
        },

        // 理论题
        getTheory() {
            const { matchPlanId, matchPattern, playerId, mainVersion, subVersion } = this.playerDetail;
            const teamId = matchPattern == 0 ? `${this.playerDetail.teamId}${mainVersion}${subVersion}` :
                `${parseInt(matchPlanId.toString().substr(-4))}${playerId}${mainVersion}${subVersion}`
            Api.getTheory({
                matchPlanId,
                matchPattern,
                teamId: teamId
            })
                .then(res => {
                    if (res.code === "0") {
                        let answerItemList = JSON.parse(sessionStorage.getItem('answerItemList')) // 非组合题答案
                        let newAnswerObj = {}
                        answerItemList.forEach(item => {
                            newAnswerObj[item.questionId] = item.answer
                        })

                        let paperContent = JSON.parse(res.data.paperContent);
                        let arr = paperContent[0].testPaperPartsList[0].testPaperSectionsList;
                        let paperAnswer = JSON.parse(res.data.paperAnswer);
                        let answerItemListArr = res.data.answerItemList
                        let allScore = res.data.answerItemList
                        let studentAnswer = {}
                        let paperAnswer_copy = {}
                        if (res?.data?.answerItemList?.length) {
                            for (let k of res.data.answerItemList) {
                                studentAnswer[k.questionId] = k.answer
                                paperAnswer_copy[k.questionId] = k.questionAnswer
                            }
                        }
                        this.theoryList = []
                        // 填空题查看答案
                        this.thirdList = []

                        this.defaultQuestionNum = 1
                        arr.forEach((val) => {
                            
                            let obj = {};
                            obj.sectionName = val.sectionName;
                            obj.sectionPrompt = val.sectionPrompt;
                            obj.questions = [];

                            let thirdObj = {};
                            thirdObj.sectionName = val.sectionName;
                            thirdObj.sectionPrompt = val.sectionPrompt;
                            thirdObj.questions = [];

                            val.testPaperQuestionsList.forEach((item) => {
                                let question = {};
                                try {
                                    if (item.questionDto.internalTypeId !== 9 && item.questionDto.internalTypeId !== 10) {
                                        question.internalTypeId = item.questionDto.internalTypeId;
                                        question.questionContent = item.questionDto.questionContent;
                                        question.items = item.questionDto.items;

                                        question.studentAnswers = newAnswerObj[item.questionId] // 非组合题答案:
                                        question.questionAnswer = paperAnswer[item.questionId];
                                        question.studentAnswer = paperAnswer[item.questionId];
                                        // question.newQuestionAnswer = answerItemListArr[item.questionId]

                                        question.questionAnswerArr = question.internalTypeId == 2 ? paperAnswer[item.questionId].split(',') : [];
                                        question.studentAnswerArr = question.internalTypeId == 2 ? studentAnswer[item.questionId]?.split(',') : [];
                                        // question.questionAnalysis = item.questionDto.questionAnalysis;
                                        question.flag = true;
                                        // question.score = item.questionDto.score;
                                        question.score = item.score;
                                        question.questionNum = this.defaultQuestionNum++;
                                        question.questionId = item.questionDto.id;
                                        question.childQuestions = [];


                                        // 处理填空题题干
                                        if (question.internalTypeId === 4 && answerItemListArr.length > 0) {
                                            console.log(studentAnswer[item.questionId], item)
                                            // 学生作答
                                            question.studentQuestionAnswer = studentAnswer[item.questionId] ? JSON.parse(studentAnswer[item.questionId]) : []
                                            // // // // 正确答案
                                            question.newQuestionAnswer = paperAnswer_copy[item.questionId] ? JSON.parse(paperAnswer_copy[item.questionId]) : []
                                        }
                                        if (question.internalTypeId === 6) {
                                            item.questionDto.childQuestions.forEach((m) => {
                                                let childQuestionsObj = {};
                                                childQuestionsObj.internalTypeId = m.internalTypeId;
                                                childQuestionsObj.questionContent = m.questionContent;
                                                childQuestionsObj.items = m.items;
                                                // childQuestionsObj.questionAnswer = m.questionAnswer;
                                                // 解决答案回显bug!!!
                                                m.questionAnswer = paperAnswer[m.id]
                                                childQuestionsObj.questionAnswer = paperAnswer[m.id];
                                                childQuestionsObj.questionAnswerArr = childQuestionsObj.internalTypeId == 2 ? m.questionAnswer.split(',') : [];
                                                childQuestionsObj.questionAnalysis = m.questionAnalysis;
                                                childQuestionsObj.questionId = m.id;
                                                childQuestionsObj.questionNum = this.defaultQuestionNum++;
                                                childQuestionsObj.flag = true; 
                                                childQuestionsObj.score = item.scoreDistribution ? JSON.parse(item.scoreDistribution)[m.id] : m.score;

                                                console.log(childQuestionsObj, 'childQuestionsObj')

                                                // 插入单独判数据
                                                question.childQuestions.push(childQuestionsObj);
                                                // 过滤单独判数据
                                                question.childQuestions = question.childQuestions.filter(item => {
                                                    return item.internalTypeId == 1 || item.internalTypeId == 2 || item.internalTypeId == 3
                                                })

                                                // 单独判添加题目总分
                                                question.childQuestions.forEach(ele => {
                                                    console.log(ele, '----')
                                                    let obj = allScore.find(item => ele.questionId == item.questionId)
                                                    ele.allScore = obj.socre
                                                    ele.answer = obj.answer
                                                })
                                                if(m.internalTypeId == 4) {
                                                    m.studentQuestionAnswer = studentAnswer[m.id] ? JSON.parse(studentAnswer[m.id]) : []
                                                    m.newQuestionAnswer = paperAnswer_copy[m.id] ? JSON.parse(paperAnswer_copy[m.id]) : []
                                                    thirdObj.questions.push(m)
                                                }

                                            });
                                            this.defaultQuestionNum--;
                                        }

                                        if (question.internalTypeId === 6 && !question.childQuestions?.length) {
                                            return
                                        }
                                        if (item.questionDto.internalTypeId == 4) {
                                            thirdObj.questions.push(question);
                                        } else {
                                            obj.questions.push(question);
                                        }
                                    }

                                } catch (err) {
                                    console.log(err)
                                }

                            });
                            if (obj.questions.length) {
                                this.theoryList.push(obj);
                            }
                            if (thirdObj.questions.length) {
                                this.thirdList.push(thirdObj);
                                console.log(this.thirdList, 'this.thirdList')
                            }
                        });
                    }

                })
        },
        // // 查询试卷信息
        getInfoOfPaperCode() {
            this.loading = true;
            // console.log(this.playerDetail)
            Api.getInfoOfPaperCode(this.playerDetail.paperCode).then(res => {
                if (res.code === "0") {
                    this.listTS = [];
                    let res_data = JSON.parse(res.data);
                    let arr = res_data[0].testPaperPartsList[0].testPaperSectionsList;
                    let questionArr = [];
                    [].forEach.call(arr, item => {
                        [].forEach.call(item.testPaperQuestionsList, val => {
                            val.questionDto.fullScore = val.score;
                            let scoreObj = val.scoreDistribution ? JSON.parse(val.scoreDistribution) : {};
                            if (val.questionDto.internalTypeId === 6) {
                                [].forEach.call(val.questionDto.childQuestions, singleVal => {
                                    singleVal.isShowMore = false;
                                    singleVal.fullScore = scoreObj[singleVal.id];
                                    questionArr.push(singleVal)
                                })
                            } else {
                                val.questionDto.isShowMore = false;
                                questionArr.push(val.questionDto)
                            }
                        })
                    });

                    [].forEach.call(questionArr, (item, index) => {
                        item.questionNum = index + 1;
                        if (item.internalTypeId === 9 || item.internalTypeId === 10) {
                            this.listTS.push(item);
                        }
                    })
                    this.getMatchScoreList();

                } else {
                    this.$message.error(res.msg);
                    this.loading = false;
                }
            }).catch(err => {
                console.log(err);
            });
        },

        // 查询试卷所有题得分  ---  大赛
        getMatchScoreList() {
            this.list = [];
            this.contentList = [];
            let params = {};
            const { matchPlanId, matchPattern, playerId, mainVersion, subVersion } = this.playerDetail;
            const teamId = matchPattern == 0 ? `${this.playerDetail.teamId}${mainVersion}${subVersion}` :
                `${parseInt(matchPlanId.toString().substr(-4))}${playerId}${mainVersion}${subVersion}`
            if (this.playerDetail.matchPattern == 0) {
                params = {
                    matchPattern: matchPattern === 2 ? 1 : matchPattern,
                    teamId,
                    matchPlanId: this.playerDetail.matchPlanId,
                    paperCode: this.playerDetail.paperCode,
                }
            } else {
                params = {
                    matchPattern: matchPattern === 2 ? 1 : matchPattern,
                    // userId: this.playerDetail.playerId,
                    teamId,
                    matchPlanId: this.playerDetail.matchPlanId,
                    paperCode: this.playerDetail.paperCode,
                }
            }
            Api.getRaceScoreLog(params).then(res => {
                if (res.code === "0") {
                    if (res.data == null || res.data.length == 0) {
                        this.list = this.listTS;
                        return;
                    }
                    this.contentList = JSON.parse(res.data.content);
                    //   console.log(this.contentList);
                    [].forEach.call(this.listTS, item => {
                        this.$set(item, "questionResult", '-');
                        this.$set(item, 'blankStatus', 0);
                        // this.$set(item, "canGoInto", false);
                        [].forEach.call(this.contentList, val => {
                            // console.log(item.id, val)
                            if (item.id === val.questionId) {
                                console.log(val.questionResult)
                                this.$set(item, "questionResult", val.questionResult);
                                this.$set(item, 'blankStatus', val.blankStatus)
                                // this.$set(item, "canGoInto", true);
                            }
                        })
                    })
                    this.list = this.listTS;

                } else {
                    this.$message.error(res.msg);
                    this.list = this.listTS;
                }
            }).catch(err => {
                console.log(err);
            }).finally(() => {
                this.loading = false;
            })

        },


        // 查看评分详情
        goInto(val, i) {
            this.pageIndex = sessionStorage.setItem("pageIndex", i);
            sessionStorage.setItem("questionId", val.id);
            sessionStorage.setItem("questionContent", val.questionContent);
            sessionStorage.setItem('questionData', JSON.stringify(val))
            sessionStorage.setItem('commonUrl', JSON.stringify(this.$route.fullPath))
            let q = this.__Base64.encode(JSON.stringify({ time: +new Date() }))
            localStorage.setItem('resultVal', JSON.stringify(this.playerDetail))
            localStorage.setItem('playerInfo', JSON.stringify(this.playerDetail))
            this.$router.push(`/scoreDetail?q=${q}`)
            // let isSaiWu = sessionStorage.getItem('isSaiWu')
            // this.isSaiWu = isSaiWu
            // if(isSaiWu == 'SaiWu') {
            //     this.$emit("changeProgress", false)
            // } else {
            //     this.$emit("changeProgress", "gradeDetails")
            // }

        },
        // 切换分页
        currentPageFn(val) {
            this.pageNum = val;
            this.searchBtn();
        },
        sizeChangeFn() {

        },
        goBackBtn() {
            sessionStorage.removeItem("pageIndex");
            this.$emit("goBack", "list")
        },
    }
};
</script>

<style rel="stylesheet/scss" scoped lang="scss">
.page-gradeQueryResult {
    width: 100%;
    height: calc(100vh - 203px);
    margin: 0 auto;
    // min-width: 1200px;
    // height: 100%;
    font-size: 14px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);

    .gradeQueryResult-head {
        line-height: 48px;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        padding: 0 10px;

        .goback {
            color: #9498a3;
            cursor: pointer;
            margin-right: 10px;
            vertical-align: top;

            &:hover {
                color: rgba(83, 151, 247, 1);
            }

            i {
                display: inline-block;
                width: 20px;
                height: 20px;
                line-height: 20px;
                background-color: #f0f1f5;
                border-radius: 50%;
                text-align: center;
                color: #b2b8c9;
                margin-right: 5px;
            }
        }

        .head-span-line {
            display: inline-block;
            height: 14px;
            border-left: 4px solid rgba(83, 151, 247, 1);
            color: rgba(83, 151, 247, 1);
            margin-right: 4px;
        }

        .head-span-word {
            font-weight: bolder;
            font-size: 20px;
        }

        .head-span-word-small {
            font-size: 14px;
            color: #9498A3;
            margin-left: 15px;
        }

        >div {
            width: 100px;
            text-align: center;
            cursor: pointer;

            >div {
                height: 12px;
                font-size: 16px;
            }

            img {
                width: 34px;
            }
        }
    }

    .gradeQueryResult-search {
        height: 48px;
        line-height: 48px;
        background-color: #f0f3fa;
        padding: 0px 10px;

        .el-button {
            margin: 10px 0px 0px 10px;
        }
    }

    .gradeQueryResult-main {
        width: 100%;
        height: calc(100% - 100px);
        position: relative;
        overflow-y: auto;
        border-bottom: 1px solid #eaeefb;
        border-radius: 3px;
        padding: 10px;
        box-sizing: border-box;

        .questionMask {
            height: 120px;
            overflow: hidden;
        }

        .questionInfo {
            padding: 10px;
            background-color: #f4f7fe;
            border-radius: 3px;
            margin-bottom: 10px;
            position: relative;

            .flex_header {
                display: flex;
                display: -webkit-flex;
                justify-content: space-between;
                align-items: center;
            }

            &:hover {
                box-shadow: 0px 0px 5px #cccccc;
            }

            .num {
                font-size: 16px;
                font-weight: bolder;
            }

            .child {
                cursor: pointer;
                color: #5397F7;
            }

            .question_title {
                margin-bottom: 5px;
                color: #9498a3;

                button {
                    float: right;
                    background-color: #b4bbcd;
                    border: #b4bbcd;

                    &:hover {
                        background-color: #a2a4ab;
                    }
                }
            }

            .div_content {
                clear: both;
                width: 99%;
                text-align: justify;
                margin-bottom: 10px;

                /deep/ img {
                    max-width: 90%;
                    display: block;
                }

                /deep/ p {
                    word-break: break-word;
                }
            }
        }

        .selected {
            background: #d0cccc;
        }

        .noDatas {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            text-align: center;

            p {
                color: #909399;
            }

            img {
                width: 200px;
            }
        }
    }

    .gradeQueryResult-main-noExam {
        height: calc(100% - 150px);
    }

    /deep/ p,
    /deep/ ul {
        margin: 0;
    }
}

/deep/ .el-divider {
    margin: 10px 0px 5px;
}

// 滚动条
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
    width: 8px;
    /*滚动条宽度*/
    height: 6px;
    /*滚动条高度*/
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    /*滚动条的背景区域的圆角*/
    /*background-color: red;!*滚动条的背景颜色*!*/
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
    border-radius: 10px;
    /*滚动条的圆角*/
    box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: rgba(0, 0, 0, 0.5);
    /*滚动条的背景颜色*/
}

.section {
    width: 100%;

    .test {
        background: #fafcfd;
        padding-top: 15px;
        padding-bottom: 20px;

        .test-item {
            margin-bottom: 40px;

            .title {
                color: #333333;
                font-size: 16px;
                font-weight: 600;
                margin-bottom: 16px;

                span {
                    font-size: 12px;
                    font-weight: 400;
                }
            }

            .test_small {
                margin-bottom: 40px;

                .text_index {
                    font-size: 14px;
                    color: #333333;
                    font-weight: 600;
                    margin-right: 10px;
                }

                .text_index1 {
                    float: left;
                    font-size: 14px;
                    color: #333333;
                    font-weight: 600;
                    line-height: 26px;
                    margin-right: 10px;
                }

                .test_small_title {
                    vertical-align: top;
                    font-size: 14px;
                    margin-bottom: 16px;
                    display: inline-block;

                    p {
                        display: inline-block;

                        span {
                            line-height: 24px;
                        }
                    }

                    /deep/ p {
                        img {
                            max-width: 900px;
                        }

                        .embed-innerApp {
                            display: inline-block;
                            border: 0px;
                            border-bottom: 1px solid black;
                            width: 60px;
                            text-align: center;
                            background-color: transparent;
                        }
                    }
                }

                .test_small_title1 {
                    font-size: 14px;
                    margin-bottom: 16px;

                    p.text {
                        width: 100%;
                        line-height: 26px;

                        /deep/ p {
                            img {
                                display: block;
                                max-width: 100%;
                            }
                        }

                        span {
                            line-height: 24px;
                        }

                    }
                }

                .answer_radio {
                    display: inline-block;

                    span {
                        display: inline-block;
                        padding: 0 30px;
                        color: #5397f7;
                        font-size: 14px;
                    }
                }

                .panduan {
                    line-height: 24px;
                }

                .answer {
                    margin-left: 34px;
                    margin-top: 10px;

                    .el-radio-group {
                        width: 100%;
                    }

                    li {
                        margin-bottom: 16px;
                        width: 100%;

                        /deep/ .el-radio__input.is-disabled {
                            .el-radio__inner {
                                cursor: pointer;
                            }
                        }

                        /deep/ .el-radio__input.is-disabled+span.el-radio__label {
                            cursor: pointer;
                            color: #606266;
                        }

                        /deep/ .el-radio__label {
                            .radio_item {
                                display: inline-flex;
                            }

                            p {
                                display: inline-block;
                                white-space: pre-wrap;
                                word-wrap: break-word;
                                box-sizing: border-box;
                            }
                        }

                        /deep/ .el-checkbox__label {
                            p {
                                display: inline-block;
                            }
                        }

                        /deep/ .el-radio__input.is-disabled {
                            .el-radio__inner {
                                background-color: #fff;
                            }
                        }

                        /deep/ .el-checkbox__input.is-disabled {
                            .el-checkbox__inner {
                                background-color: #fff;
                            }
                        }

                        /deep/ .el-checkbox__input.is-disabled+span.el-checkbox__label {
                            cursor: pointer;
                            color: #606266;
                        }

                        .el-radio {
                            width: 100%;
                        }
                    }
                }

                p {
                    font-size: 14px;
                    margin-bottom: 12px;

                    span {
                        color: #5397f7;
                    }
                }

                .analysis {
                    color: #5397f7;
                    font-size: 14px;
                    cursor: pointer;
                    float: left;

                    img {
                        display: inline-block;
                        width: 10px;
                        height: 10px;
                        margin-left: 4px;
                    }
                }

                .analysis_cont {
                    float: left;
                    width: calc(100% - 105px);
                    color: #333333;
                    font-size: 14px;
                    line-height: 24px;
                    margin-bottom: 32px;
                    margin-left: 24px;
                    margin-top: -4px;
                }

                .answerShow,
                .intoSystem,
                .answerHide {
                    color: #5397f7;
                    font-size: 14px;
                    cursor: pointer;

                    img {
                        display: inline-block;
                        width: 10px;
                        height: 10px;
                        margin-left: 4px;
                    }
                }

                .intoSystem {
                    margin-left: 40px;
                }

                .commentCont {
                    position: relative;

                    .comment1 {
                        width: 0px;
                        height: 0px;
                        border: 8px transparent solid;
                        border-bottom-color: #f4f4f4;
                        position: absolute;
                        top: -15px;
                        left: 41px;
                    }

                    .comment2 {
                        background: #f4f4f4;
                        min-height: 105px;
                        max-height: 396px;
                        border-radius: 4px;
                        margin-top: 10px;
                        padding: 16px;
                        overflow: auto;
                    }

                    .comment3 {
                        width: 0px;
                        height: 0px;
                        border: 9px transparent solid;
                        border-bottom-color: rgba(244, 244, 244, 1);
                        position: absolute;
                        top: -15px;
                        left: 40px;
                    }
                }

                .combination {
                    padding-top: 15px;
                    padding-bottom: 25px;

                    .groupQuestion {
                        clear: both;
                        margin-bottom: 10px;

                        .question_content {
                            max-width: 100%;

                            span {
                                float: left;
                                margin-right: 10px;
                                line-height: 21px;
                                font-weight: 600;
                            }

                            p.text {
                                /deep/ p {
                                    display: inline-block;
                                    line-height: 24px;
                                    width: 91%;

                                    img {
                                        display: block;
                                        max-width: 100%;
                                    }
                                }
                            }
                        }
                    }

                    .test_small_title {
                        /deep/ p {
                            line-height: 24px;
                        }
                    }

                    .analysis {
                        margin-bottom: 15px;
                    }

                    .question_index {
                        display: block;
                        font-weight: 600;
                        font-size: 14px;
                    }
                }

                .line {
                    height: 0px;
                    border: 1px solid rgba(83, 151, 247, 1);
                }
            }
        }
    }
}

.internalTypeBox {
    display: flex;
    justify-content: space-between;

    .internalTypeLeft {
        flex: 50%;
        display: flex;
        flex-shrink: 0;
    }

    .internalTypeRight {
        flex: 50%;
        display: flex;
        flex-shrink: 0;
    }

    .xsda {
        width: 70px;
    }

    .ulBox {
        width: calc(100% - 70px);
    }
}
</style>
<style>
.thirdDiv .this_a_blank {
    pointer-events: none !important;
    padding-left: 25px !important;
    box-sizing: border-box;

}

.thirdDiv input::-webkit-input-placeholder {
    color: red;
    font-weight: 700;
    font-size: 20px;
}
</style>
